import React from 'react';
import { SimpleTableHead, SimpleTableRow } from 'cdk-radial';
import { StickySimpleTableHeader } from '../../common/StyledComponents';

export default function GetOrderTableHeaders(props: any): JSX.Element {
  return (
    <SimpleTableHead>
      <SimpleTableRow>
        <StickySimpleTableHeader colSpan="2" textAlign="left">
          Purchase Order
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="2" textAlign="left" >
          Order Date
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="2" textAlign="left" >
          Order Type
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          Source
        </StickySimpleTableHeader>

        <StickySimpleTableHeader
          textAlign="left"
          colSpan="1"
        >
        </StickySimpleTableHeader>
      </SimpleTableRow>
    </SimpleTableHead>
  );
}
